import { create } from 'zustand'

export interface ChatNotification {
  id: number
  senderName: string
  senderInitials: string
  senderColor: string
  text: string
  conversationId: string
}

interface ChatNotifState {
  items: ChatNotification[]
  show: (notif: Omit<ChatNotification, 'id'>) => void
  dismiss: (id: number) => void
}

let nextId = 1
const recentIds = new Set<string>()

export const useChatNotifStore = create<ChatNotifState>()((set) => ({
  items: [],
  show: (notif) => {
    const dedupKey = `${notif.conversationId}-${notif.text.slice(0, 30)}`
    if (recentIds.has(dedupKey)) return
    recentIds.add(dedupKey)
    setTimeout(() => recentIds.delete(dedupKey), 3000)

    const id = nextId++
    set((s) => ({ items: [...s.items, { ...notif, id }] }))
    setTimeout(() => set((s) => ({ items: s.items.filter((i) => i.id !== id) })), 5000)
  },
  dismiss: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
}))
